<template>
<div>
<div class="unsub-cont">
  <div class="unsub-msg-box">
    <div class="unsub-logo"><a href="https://www.authorizelocal.com"><img src="autohrizeLocalLogo.png"></a></div>
    <div class="unsub-msg">
        <h2>Do you want to break up?</h2>
        <p>It saddens us to see you go. You have opened wounds in our hearts. But it's not your fault, it's us. We believe that we will meet again in the future and this time you will love us.</p>
    </div>
    <div class="unsub-buttons">
        <div class="al-button gray-button">Unsubscribe</div>
        <div class="al-button green-button">Keep me Subscribed</div>
    </div>
  </div>
  </div>
  <the-footer />
</div>
</template>

<script>
import TheFooter from '@/layouts/components/TheFooter.vue'
export default {
  components: {
    TheFooter
  }
}
</script>

<style lang="scss">
.unsub-cont{
    width:100vw;
    height:100vh;
    display:flex;
    justify-content: center;
    align-items:center;
} 
.unsub-logo{
            text-align: center;
        img {
            display:block;
            margin:0 auto 50px auto;
            width:300px;
        }
}
.unsub-msg-box {
    width:50%;
    height:max-content;
    box-shadow:0px 0px 10px 5px rgba(0,0,0,.1);
    border-radius:7px;
    padding:50px;
    text-align:center;
}
.unsub-msg{
margin:20px 0px;
h2{
    text-transform: uppercase;
    margin-bottom:20px;
}
}
.unsub-buttons{
    display:flex;
    justify-content: space-between;
    .al-button{
        width:45%;
        display:flex;
        align-items:center;
        justify-content: center;
    }
}
@media (max-width:768px){
.unsub-msg-box{
        width:95%;
        box-shadow:none;
    }
.unsub-buttons{
    .al-button{
        font-size:12px;
    }
}
}
    </style>
